import './global.js';
import 'webpack-jquery-ui';
import 'jquery-ui-touch-punch';
import { v$, compose, listen, scroll } from './includes/helpers';
import { creditsCalculator } from './includes/creditsCalculator';
import { closePopup, openPopup } from './includes/popupForm';

const sumInput = v$('.js-credits_sum')[0],
      termInput = v$('.js-credits_term')[0],
      creditRes = v$('.appliances_result')[0],
      promoCodeLink = v$('.promo-code-text')[0],
      promoPopUp = v$('#promo')[0],
      promoPopUpClose =v$('#promo .popup-close')[0],
      promoCodeWrap = v$('.promo-code-wrap')[0];

if (promoCodeWrap) {
  let parentOneDay = document.querySelector('.promo-code-wrap');
  let inputPromoType = document.querySelector('#type');
  inputPromoType.value = parentOneDay.getAttribute('id').replace(/promo-/g, "");


  promoCodeLink.addEventListener('click', (e) => {
    e.preventDefault();
    openPopup(promoPopUp);
  })

  promoPopUpClose.addEventListener('click', (e) => {
    e.preventDefault();
    closePopup(promoPopUp);
  })
}


const calcData =
  process.env.NODE_ENV === 'development'
    ? {
      '0-7': { '0-1500': 0.89, '1500-3000': 0.78, '3000-3000': 2 },
      '15-30': { '0-700': 0.67 }
    }
    : window.creditsCalcData;
//call imported functions
creditsCalculator(calcData, sumInput, termInput, creditRes);

